<div class="modal-body d-flex flex-column align-items-center gap-3 m-0 px-5 py-4">
  <img [src]="data.image" alt="" style="width: 5rem" *ngIf="data.image" />
  <h5 class="mb-3">{{ data.title }}</h5>
  <p class="mb-0">
    {{ data.message }}
  </p>

  <div *ngIf="data.steps?.length" class="">
    <div i18n class="align-items-stretch text-semi-bold">Next Steps:</div>
    <ul class="list-unstyled">
      <li *ngFor="let item of data.steps"><i class="fas fa-check-circle text-success2 text-xs"></i> {{ item }}</li>
    </ul>
  </div>

  <div class="d-flex align-items-center gap-2">
    <ng-container *ngFor="let item of data.buttons">
      <button [ngClass]="item.classes" (click)="onClick(item)">
        <i [ngClass]="item.icon" *ngIf="item.icon"></i> {{ item.label }}
      </button>
    </ng-container>
  </div>
</div>
